export const CURRENCIES = {
  USD: { symbol: "$", locale: "en-US", label: "USD" },
  INR: { symbol: "₹", locale: "en-IN", label: "INR" },
};

export const CURRENCY_CODES = Object.keys(CURRENCIES);

export function currencySymbol(code = "USD") {
  return (CURRENCIES[code] || CURRENCIES.USD).symbol;
}

export function formatMoney(amount, code = "USD") {
  const c = CURRENCIES[code] || CURRENCIES.USD;
  const n = Number(amount) || 0;
  return `${c.symbol}${n.toLocaleString(c.locale)}`;
}

/**
 * Group a list of records by their currency and sum a numeric field.
 * Returns e.g. { USD: 4500, INR: 250000 }.
 */
export function sumByCurrency(records, field, defaultCurrency = "USD") {
  const out = {};
  for (const r of records || []) {
    const cur = r?.currency || defaultCurrency;
    out[cur] = (out[cur] || 0) + (Number(r?.[field]) || 0);
  }
  return out;
}
